(ns ycweb.app.blitz.picking.picking
  (:require
   [ycweb.components.forms :as forms]
   [rum.core :as rum]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.util.core :as u]
   [ycweb.components.transitions :as t]
   [ycweb.components.common :as cmn]
   [util.string :as str]
   [ycweb.components.wrapper :as w]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.util.sound :as sound]))

(def steps
  (forms/setup-steps
    [{:key :pickingtypes :title "Choose Picking Type"}
     {:key :picking-groups :title "Choose Picking Group"}
     {:key :picking-areas :title "Choose Picking Area"}
     {:key :picking-locations :title "Choose Picking Location"}
     {:key :scan-tolocation :title "Scan Basket/Trolley"}
     {:key :items :title "Pick Item"}
     {:key :scan-fromlocation :title "Scan Location"}
     {:key :scan-item :title "Scan Item"}]))

(defmethod grid/action :picking/change-basket [app-atom _ _]
  (grid/dispatch-action app-atom :picking/basket (get-in @app-atom [:picking :sub-location])))

(defmethod grid/action :picking/pickingstop [app-atom _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [sub-location keepaside?]} (get-in @app-atom [:picking])]
    (comms/send :picking/claim-finish
      {:location_name (:area sub-location)})
    (cond
      keepaside?
      (t/transition-next app-atom :keepaside/choose-type)

      :else
      (comms/send :picking/list-pickingtypes {}))))

(defmethod comms/receive :picking/auto-claim-next
  [app-atom {:keys [items picking-area sub-location picking-areas tolocation finished?]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :picking assoc
    :sub-location sub-location
    :picking-area picking-area
    :pickingareas picking-areas
    :current-item (first items)
    :items (rest items)
    :scanned 0
    :tolocation tolocation)

  (cond
    (and finished? (get-in @app-atom [:picking :keepaside?]))
    (grid/dispatch-action app-atom :keepaside/deliver-items {})

    finished?
    (t/transition-next app-atom :picking/pickingarea)

    :else
    (grid/dispatch-action app-atom :picking/location {})))

(defmethod grid/action :picking/auto-claim-next [app-atom {:keys [picking-group picking-area current-aisle]}]
  (toaster/open-subtle-progress app-atom)
  (comms/send :picking/auto-claim-next
    {:picking-group picking-group
     :picking-area picking-area
     :current-aisle current-aisle
     :scan (get-in @app-atom [:picking :tolocation :barcode])}))

(defn next-item [app-atom picking-group items]
  (let [sub-location (get-in @app-atom [:picking :sub-location])
        picking-area (get-in @app-atom [:picking :picking-area])]
    (cond
      (empty? items)
      (do
        (comms/send :picking/claim-finish
          {:location_name (:area sub-location)})
        (if (:auto-claim sub-location)
          (grid/dispatch-action app-atom :picking/auto-claim-next
            {:picking-group picking-group
             :picking-area picking-area
             :current-aisle sub-location})
          (grid/dispatch-action app-atom :picking/pickingarea picking-group)))

      :else
      (do
        (swap! app-atom update :picking assoc
          :current-item (first items)
          :items (rest items)
          :scanned 0)
        (grid/dispatch-action app-atom :picking/location {})))))

(defmethod comms/receive :picking/item-missing [app-atom {:keys [pickingsession_id]}]
  (toaster/close-subtle-progress app-atom)
  (let [{:keys [items picking-group]}
        (get-in @app-atom [:picking])]

    (swap! app-atom assoc-in [:picking :pickingsession_id] pickingsession_id)

    (next-item app-atom picking-group items)))

(defmethod grid/action :picking/item-missing [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [start-time scanned current-item sub-location tolocation pickingsession_id]}
        (get-in @app-atom [:picking])]
    (comms/send :picking/item-missing
      {:pickingsession_id pickingsession_id
       :tolocation tolocation
       :item current-item
       :picking-location sub-location
       :scanned-qty scanned
       :start-time start-time
       :end-time (js/Date.)})))

(defmethod grid/action :picking/item-missing-confirm [app-atom _ _]
  (grid/confirm-modal app-atom
    {:title "Confirm item missing?"
     :text "This will mark the item as lost."
     :confirm-key :picking/item-missing}))

(defmethod comms/receive :picking/item-scan [app-atom {:keys [pickingsession_id scan-uuid]}]
  (toaster/close-subtle-progress app-atom)
  (sound/play :scan)
  (let [{:keys [scanned current-item items picking-group]}
        (get-in @app-atom [:picking])]

    (cond
      (not= (inc scanned) (:qty current-item))
      (swap! app-atom update :picking assoc
        ;;todo replace with dt/now and update serverside
        :start-time (js/Date.)
        :pickingsession_id pickingsession_id
        :scan-uuid scan-uuid
        :scanned (inc scanned))

      :else
      (do
        (swap! app-atom update :picking assoc
          :pickingsession_id pickingsession_id)
        (next-item app-atom picking-group items)))))

(defmethod grid/action :picking/item-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [start-time scanned current-item scan-uuid sub-location tolocation fromlocationbarcode pickingsession_id]}
        (get-in @app-atom [:picking])]
    (comms/send :picking/item-scan
      {:pickingsession_id pickingsession_id
       :tolocation tolocation
       :fromlocationbarcode fromlocationbarcode
       :item current-item
       :picking-location sub-location
       :scan scan
       :scan-uuid scan-uuid
       :scanned-qty (inc scanned)
       :start-time start-time
       :end-time (js/Date.)})))

(defmethod flow/barcode-dispatch-screen :picking/item [_ app-atom scan]
  (grid/dispatch-action app-atom :picking/item-scan {:scan scan}))

(rum/defc item-screen < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:picking])
        trolley (cmn/curact current-atom :tolocation)
        scanned (cmn/curact current-atom :scanned)
        picking-group (cmn/curact current-atom :picking-group)
        group-colour (:groupcode picking-group)
        {:keys [features brand product lname binname bincolour qty images barcode]}
        (cmn/curact current-atom :current-item)]
    (w/wrapper app-atom "Picking"
      {:steps steps
       :step :scan-item
       :modal-fn
       #(grid/menu-modal app-atom
          {:items
           [{:label "Query Item"
             :action :picking/query-item}
            {:label "Can't Find Item"
             :action :picking/item-missing-confirm}
            {:label "Change Basket"
             :action :picking/change-basket}
            {:label "Stop Picking"
             :action :picking/pickingstop
             :style
             {:full true :large true :negative true
              :text-default true :icon-class :3-2}}
            {:label "Close"
             :action :picking/cancel-modal
             :style
             {:full true :large true :text-link true :on-dark true}}]})}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard :flush])}
         "Scan items in:"]
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b lname " "]
         (when binname
           [:span {:class (u/bem :pill [:large :picking-bin bincolour])}
            binname])
         [:span.heading__subtext
          "Trolley: " [:b (:name trolley)]]]]
       [:div.slats
        [:article.card.product-card
         [:figure.product-card__hero
          [:span.product-card__scan-count
           (str (or scanned 0) " / " qty)]
          [:img.product-card__image
           {:src (u/cloudinary (:public_id (first images)) {:c "lpad"}) :alt ""}]]
         [:div.product-card__content
          [:h1.product-card__title
           [:span.product-card__brand brand]
           [:span.product-card__name product]]
          (when (u/presence features)
            [:div.product-card__variation-wrapper
             "Variation: " [:span.product-card__variation features]])
          [:div.product-card__barcode
           "Barcode: " [:b.u-barcode.u-block barcode]]
          [:div.product-card__footnote
           [:span.pill
            {:class (keyword (str "pill--" (str/lower group-colour) "-orders"))}
            (:displayname picking-group) " order"]]]]]]
      ;;To be added at a later stage.
      [#_[:aside.page-body__footer.u-margin-top-16
          [:p.u-text-center
           {:class (u/bem :paragraph [:flush])}
           [:a.text-link
            {:on-click #(grid/open-modal app-atom :picking/details-modal)}
            "Show me more details"]]]]
      (grid/pos-call-to-action
        {:left-plain true
         :right-text "Scan Item"
         :right-plain true}))))

(defmethod flow/render-screen :picking/item [app-atom _]
  (item-screen app-atom))

(defmethod comms/receive :picking/location-scan [app-atom {:keys [fromlocationbarcode scan-uuid]}]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :picking/item)
  (swap! app-atom update :picking assoc
    :fromlocationbarcode fromlocationbarcode
    :scan-uuid scan-uuid))

(defmethod grid/action :picking/location-scan [app-atom {:keys [scan]} _]
  (sound/play :scan)
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [current-item]} (get-in @app-atom [:picking])]
    (comms/send :picking/location-scan
      {:scan scan
       :current-item current-item})))

(defmethod flow/barcode-dispatch-screen :picking/location [_ app-atom scan]
  (grid/dispatch-action app-atom :picking/location-scan {:scan scan}))

(defmethod comms/receive :picking/bin-missing [app-atom {:keys [pickingsession_id]}]
  (toaster/close-subtle-progress app-atom)
  (let [{:keys [items current-item picking-group]} (get-in @app-atom [:picking])
        items (remove #(= (:location_id current-item) (:location_id %)) items)]

    (swap! app-atom assoc-in [:picking :pickingsession_id] pickingsession_id)

    (next-item app-atom picking-group items)))

(defmethod grid/action :picking/bin-missing [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [start-time scanned current-item sub-location tolocation pickingsession_id]}
        (get-in @app-atom [:picking])]
    (comms/send :picking/bin-missing
      {:pickingsession_id pickingsession_id
       :tolocation tolocation
       :item current-item
       :picking-location sub-location
       :scanned-qty scanned
       :start-time start-time
       :end-time (js/Date.)})))

(defmethod grid/action :picking/bin-missing-confirm [app-atom _ _]
  (grid/confirm-modal app-atom
    {:title "Confirm missing bin?"
     :text "This will mark the bin and all of its items as lost."
     :confirm-key :picking/bin-missing}))

(rum/defc location-screen < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:picking])
        trolley (cmn/curact current-atom :tolocation)
        scanned (cmn/curact current-atom :scanned)
        picking-group (cmn/curact current-atom :picking-group)
        group-colour (:groupcode picking-group)
        {:keys [features brand product lname binname bincolour qty images barcode]}
        (cmn/curact current-atom :current-item)]
    (w/wrapper app-atom "Picking"
      {:steps steps
       :step :scan-fromlocation
       :modal-fn
       #(grid/menu-modal app-atom
          {:items
           [{:label "Change Basket"
             :action :picking/change-basket}
            {:label "Can't Find Item"
             :action :picking/item-missing-confirm}
            (when binname
              {:label "Can't Find Bin"
               :action :picking/bin-missing-confirm})
            {:label "Stop Picking"
             :action :picking/pickingstop
             :style
             {:full true :large true :negative true
              :text-default true :icon-class :3-2}}
            {:label "Close"
             :action :picking/cancel-modal
             :style
             {:full true :large true :text-link true :on-dark true}}]})}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard :flush])}
         "Scan location:"]
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b lname " "]
         (when binname
           [:span {:class (u/bem :pill [:large :picking-bin bincolour])}
            binname])
         [:span.heading__subtext
          "Trolley: " [:b (:name trolley)]]]]
       [:div.slats
        [:article.card
         {:class (u/bem :product-card [:is-disabled])}
         [:figure.product-card__hero
          [:span.product-card__scan-count
           (str (or scanned 0) " / " qty)]
          [:img.product-card__image
           {:src (u/cloudinary (:public_id (first images)) {:c "lpad"}) :alt ""}]]
         [:div.product-card__content
          [:h1.product-card__title
           [:span.product-card__brand brand]
           [:span.product-card__name product]]
          (when (u/presence features)
            [:div.product-card__variation-wrapper
             "Variation: " [:span.product-card__variation features]])
          [:div.product-card__barcode
           "Barcode: " [:b.u-barcode.u-block barcode]]
          [:div.product-card__footnote
           [:span.pill
            {:class (keyword (str "pill--" group-colour "-orders"))}
            (:displayname picking-group) " order"]]]]]]
      ;;To be added at a later stage.
      [#_[:aside.page-body__footer.u-margin-top-16
          [:p.u-text-center
           {:class (u/bem :paragraph [:flush])}
           [:a.text-link
            {:on-click #(grid/open-modal app-atom :picking/details-modal)}
            "Show me more details"]]]]
      (grid/pos-call-to-action
        {:left-plain true
         :right-text "Scan Location"
         :right-plain true}))))

(defmethod flow/render-screen :picking/location [app-atom _]
  (location-screen app-atom))

(defmethod grid/action :picking/location [app-atom _ _]
  (let [current-atom (rum/cursor-in app-atom [:picking])
        {:keys [lname binname bincolour qty product setof-text]} (cmn/curact current-atom :current-item)]
    (sound/tts
      (str
        lname
        ". "
        bincolour
        ", "
        (when binname (str/join " " (re-find #"\d*" binname)))
        ". "
        qty
        " "
        setof-text
        " "
        product))
    (swap! app-atom assoc-in [:picking :start-time] (js/Date.)))
  (t/transition-next app-atom :picking/location))

(defmethod comms/receive :picking/basket-scan [app-atom {:keys [scan-uuid basket items]}]
  (toaster/close-subtle-progress app-atom)
  (sound/play :scan)
  (swap! app-atom update :picking assoc
    :current-item (first items)
    :scan-uuid scan-uuid
    :items (rest items)
    :scanned 0
    :tolocation basket)
  (grid/dispatch-action app-atom :picking/location {}))

(defmethod grid/action :picking/basket-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :picking/basket-scan
    {:sub-location (get-in @app-atom [:picking :sub-location])
     :picking-group (get-in @app-atom [:picking :picking-group])
     :pickingsession_id (get-in @app-atom [:picking :pickingsession_id])
     :scan scan}))

(defmethod flow/barcode-dispatch-screen :picking/basket [_ app-atom scan]
  (grid/dispatch-action app-atom :picking/basket-scan {:scan scan}))

(rum/defc basket < rum/reactive [app-atom]
  (w/wrapper app-atom "Picking"
    {:steps steps
     :step :scan-tolocation
     :modal-fn
     #(grid/menu-modal app-atom
        {:items
         [{:label "Stop Picking"
           :action :picking/pickingstop
           :style
           {:full true :large true :negative true
            :text-default true :icon-class :3-2}}
          {:label "Close"
           :action :picking/cancel-modal
           :style
           {:full true :large true :text-link true :on-dark true}}]})}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Basket or Trolley"]]
     [:div
      [:i.u-block-center
       {:class
        (u/bem :icon [:block :enormous :light-force :barcode-scan :2-1])}]]]
    [[:aside.page-body__footer
      [:p.u-text-center
       {:class (u/bem :paragraph [:flush])}
       "Scan Basket or Trolley to start picking"]]]
    nil))

(defmethod flow/render-screen :picking/basket [app-atom _]
  (basket app-atom))

(defmethod comms/receive :picking/claim-location [app-atom {:keys [pickingsession_id scan-uuid]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :picking assoc
    :pickingsession_id pickingsession_id
    :scan-uuid scan-uuid)
  (t/transition-next app-atom :picking/basket))

(defmethod grid/action :picking/basket [app-atom picking-location]
  (toaster/open-subtle-progress app-atom)
  (swap! app-atom assoc-in [:picking :sub-location] picking-location)
  (comms/send :picking/claim-location
    {:picking-location picking-location
     :picking-group (get-in @app-atom [:picking :picking-group])}))

(defn slat-colour [colour]
  (case colour
    "red"
    [:red :red-bg]

    "blue"
    [:blue :blue-bg]

    "green"
    [:green :green-bg]

    "red-green"
    [:red-green :neutral-bg]

    "grey"
    [:neutral :neutral-bg]

    "white"
    [:neutral :neutral-bg]

    "mustard"
    [:orange :orange-bg]

    "purple"
    [:purple :purple-bg]

    [:neutral :neutral-bg]))

(rum/defc picking-location-slat < rum/reactive
  [picking-group {:keys [area age claims alloc-count]} {:keys [on-click]}]
  (let [[slat-color] (slat-colour (:colour picking-group))
        claim-count (count claims)]
    [:article.slat-wrapper
     [:div.picking-slat
      {:class (u/bem :slat [slat-color]) :on-click on-click}
      [:div.picking-slat__graphic-wrapper
       [:div.picking-slat__icon-wrapper
        [:i {:class (u/bem :icon [:2-2 :block :location])}]]]
      [:div.picking-slat__info
       [:h3
        {:class (u/bem :picking-slat__title [:large])}
        (str area " (" alloc-count ")")
        (when (pos? claim-count)
          [:span.picking-slat__claimed-text " Claimed"])]
       [:span.picking-slat__description
        "Oldest item: "
        [:b (str age " hours")]]]
      (when (pos? claim-count)
        [:div.picking-slat__user-wrapper
         (map #(u/user-profile-pic % {:w 128 :h 128} "picking-slat__user-image") claims)])]]))

(defmethod grid/action :picking/auto-claim [app-atom picking-area]
  (toaster/open-subtle-progress app-atom)
  (let [user-id (get-in @app-atom [:user :id])
        sub-locations (:data picking-area)
        claimed-location
        (or
          (get (u/index-by (comp :user_id first :claims) sub-locations) user-id)
          (first (filter (comp empty? :claims) sub-locations)))]

    (cond
      (nil? claimed-location)
      (toaster/open-toast app-atom :error "No Auto-Claimable Locations." {})

      :else
      (do
        (swap! app-atom update :picking assoc
          :picking-area picking-area
          :sub-location (assoc claimed-location :auto-claim true))
        (comms/send :picking/claim-location
          {:picking-location claimed-location
           :picking-group (get-in @app-atom [:picking :picking-group])})))))

(rum/defc picking-location < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:picking])
        picking-group (cmn/curact current-atom :picking-group)
        group-colour (:groupcode picking-group)
        picking-area (cmn/curact current-atom :picking-area)]
    (w/wrapper app-atom "Picking" {:steps steps :step :picking-locations}
      [[:div.section
        [:div.u-margin-top-24
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          (str "Claim Picking Location in " (:area picking-area))
          [:span.heading__subtext
           "for " [:b {:class (keyword (str "text-status--" (str/lower group-colour) "-orders"))}
                   (:displayname picking-group) " orders"] " (" (:alloc-count picking-group) ")"]]]]
       [:div.slats
        (concat
          [[:div.slat.action-button-slat
            {:class (u/bem :slat nil)
             :on-click #(grid/dispatch-action app-atom :picking/auto-claim picking-area)}
            [:div.action-button-slat__title
             [:b "Auto-claim location"]]
            [:div.action-button-slat__icon-wrapper
             [:i {:class (u/bem :icon [:block :arrow-right])}]]]]
          [[:div.slats
            (map
              (fn [i]
                (picking-location-slat picking-group i
                  {:on-click
                   #(grid/dispatch-action app-atom :picking/basket i)}))
              (:data picking-area))]])]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :picking/pickinglocation [app-atom _]
  (picking-location app-atom))

(defmethod grid/action :picking/pickinglocation [app-atom picking-area]
  (swap! app-atom assoc-in [:picking :picking-area] picking-area)
  (t/transition-next app-atom :picking/pickinglocation))

(rum/defc picking-area-slat < rum/reactive
  [picking-group {:keys [area age data alloc-count]} {:keys [on-click]}]
  (let [[slat-color] (slat-colour (:colour picking-group))
        claims (mapcat :claims data)
        claim-count (count claims)
        claim-limit (> claim-count 3)]
    [:article.slat-wrapper
     [:div.picking-slat
      {:class (u/bem :slat [slat-color]) :on-click on-click}
      [:div.picking-slat__graphic-wrapper
       [:span.picking-slat__icon-wrapper
        [:i {:class (u/bem :icon [:block :2-2 :location])}]]]
      [:div.picking-slat__info
       [:h3
        {:class (u/bem :picking-slat__title [:large])}
        (str area " (" alloc-count ")")]
       [:span.picking-slat__description
        "Oldest item: "
        [:b (str age " hours")]]]
      (when (pos? claim-count)

        [:div.picking-slat__user-wrapper
         (map
           #(u/user-profile-pic % {:w 128 :h 128 :no-image :div.picking-slat__user-no-image} "picking-slat__user-image")
           (if claim-limit (take 2 claims) claims))
         (when claim-limit
           [:div.picking-slat__user-count
            "+" (- claim-count 2)])])]]))

(rum/defc picking-area < rum/reactive [app-atom]
  (let [{:keys [keepaside? pickingareas picking-group selected-pickingtype pickingtypes]}
        (cmn/curact app-atom :picking)
        group-name (:displayname picking-group)
        group-colour (:groupcode picking-group)
        group-count (count (:picking-groups (get pickingtypes selected-pickingtype)))]
    (w/wrapper app-atom "Picking" {:steps steps :step :picking-areas}
      [[:div.section
        [:div.u-margin-top-24
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          "Choose Picking Area"
          [:span.heading__subtext
           "for " [:b {:class (keyword (str "text-status--" group-colour "-orders"))}
                   group-name " orders"] " (" (:alloc-count picking-group) ")"]]]]
       [:div.slats
        [[:div.slats
          (map
            (fn [i]
              (rum/with-key
                (picking-area-slat picking-group i
                  {:on-click
                   #(grid/dispatch-action app-atom :picking/pickinglocation i)})
                (:area i)))
            pickingareas)]]]]
      []
      (grid/pos-call-to-action
        {:left-fn
         (cond
           keepaside?
           #(t/transition-next app-atom :keepaside/choose-type)

           (= 1 group-count)
           #(grid/dispatch-action app-atom :picking/pickingtype nil)

           :else
           #(t/transition-next app-atom :picking/picking-group))
         :right-plain true}))))

(defmethod flow/render-screen :picking/pickingarea [app-atom _]
  (picking-area app-atom))

(defmethod comms/receive :picking/list-pickingareas [app-atom {:keys [pickingareas]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :picking assoc
    :selected-pickingarea nil
    :pickingareas pickingareas)
  (t/transition-next app-atom :picking/pickingarea))

(defmethod grid/action :picking/pickingarea [app-atom picking-group]
  (toaster/open-subtle-progress app-atom)
  (swap! app-atom assoc-in [:picking :picking-group] picking-group)
  (comms/send :picking/list-pickingareas {:picking-group picking-group}))

(rum/defc picking-group-slat < rum/reactive
  [{:keys [displayname colour alloc-count]} {:keys [on-click]}]
  (let [[slat-color slat-bg-color] (slat-colour colour)]
    [:article.slat-wrapper
     [:div.picking-slat
      {:class (u/bem :slat [slat-color slat-bg-color]) :on-click on-click}
      [:div.picking-slat__graphic-wrapper
       [:span.picking-slat__icon-wrapper
        [:span.picking-slat__size-text (str/upper-case (first displayname))]]]
      [:div.picking-slat__info
       [:h3.pickin-slat__title (str displayname " (" alloc-count ")")]]]]))

(rum/defc picking-group < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:picking])
        pickingtypes (cmn/curact current-atom :pickingtypes)
        selected-pickingtype (cmn/curact current-atom :selected-pickingtype)
        pickingtype (get pickingtypes selected-pickingtype)]
    (w/wrapper app-atom "Picking" {:steps steps :step :picking-groups}
      [[:div.u-margin-top-24
        [:div.section.section--medium
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          "Choose Client Order Type"
          [:span.heading__subtext
           "Total Items to Pick: " [:b (:alloc-count pickingtype)]]]]]
       [:div.slats
        (map
          (fn [i]
            (picking-group-slat i
              {:on-click
               #(grid/dispatch-action app-atom :picking/pickingarea i)}))
          (:picking-groups pickingtype))]]
      []
      (grid/pos-call-to-action
        {:left-fn #(grid/dispatch-action app-atom :picking/pickingtype nil)
         :right-plain true}))))

(defmethod flow/render-screen :picking/picking-group [app-atom _]
  (picking-group app-atom))

(rum/defc pickingtype < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:picking])
        pickingtypes (cmn/curact current-atom :pickingtypes)
        selected-pickingtype (rum/cursor current-atom :selected-pickingtype)
        pickingarea (get pickingtypes (rum/react selected-pickingtype))
        group-count (count (:picking-groups pickingarea))]
    (w/wrapper app-atom "Picking" {:steps steps :step :pickingtypes}
      [[:div.u-margin-top-24
        [:div.section
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          "Choose Picking Type"]]]
       [:div
        (concat
          (for [[pickingtype {:keys [alloc-count displayname]}] pickingtypes]
            [:div.section
             (forms/radio [:b (str displayname " (" alloc-count ")")]
               pickingtype selected-pickingtype)])
          [[:div.section
            (forms/radio [:b (str "Specific Order")]
              "specific" selected-pickingtype
              {:description "Input YC number to pick for order"})]])]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-next app-atom :main-menu)
         :right-text "Next"
         :right-fn
         (cond
           (zero? group-count)
           nil

           (= 1 group-count)
           #(grid/dispatch-action app-atom :picking/pickingarea
              (first (:picking-groups pickingarea)))

           :else
           #(t/transition-next app-atom :picking/picking-group))}))))

(defmethod flow/render-screen :picking/pickingtype [app-atom _]
  (pickingtype app-atom))

(defmethod comms/receive :picking/list-pickingtypes [app-atom {:keys [defaultpickingtype pickingtypes]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :picking assoc
    :keepaside? false
    :selected-pickingtype defaultpickingtype
    :pickingtypes pickingtypes)

  (t/transition-next app-atom :picking/pickingtype))

(defmethod grid/action :picking/pickingtype [app-atom _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :picking/list-pickingtypes {}))




;; location Scanning Flow
;;TODO: Switch out hardcoded values with live data
;;This will be added at a later stage.
(rum/defc detail-modal-body [app-atom]
  (let [_ (rum/cursor-in app-atom [:picking])
        image {:public_id "contentdocs/14131/otherpicture320200915100150"}]
    [[:div.modal__product-image
      [:img
       {:class (u/bem :image [:full])
        :src (u/cloudinary (:public_id image) {:c "lpad"}) :alt ""}]
      [:span.modal__product-pill
       {:class (u/bem :pill [:red])}
       "Large Item"]]
     [:header.modal__product-info.u-margin-top-32
      [:h2.modal__product-title
       [:span.modal__product-brand "Nutribullet "]
       "600W High Speed Blender"]
      [:ul.modal__product-linear-details
       [:li.modal__product-simple-detail "Variation: "
        [:b "Cream"]]
       [:li.modal__product-simple-detail "Size:/Diameter: "
        [:b "40cm"]]
       [:li.modal__product-simple-detail "Barcode: "
        [:b.u-barcode "583777759398"]]]
      [:div.u-hr]
      [:h3.modal__product-simple-header "Warehouse Locations:"]
      [:ul.tabular-list
       [:li.tabular-list__item
        [:span.tabular-list__item-icon-wrapper
         [:i {:class (u/bem :icon [:block :location])}]]
        [:span.tabular-list__item-name "U-3-B-4 "
         [:span {:class (u/bem :pill [:medium :picking-bin :green])}
          "G-45768"]]
        [:span.tabular-list__item-value
         [:b "6"]]]
       [:li.tabular-list__item
        [:span.tabular-list__item-icon-wrapper
         [:i {:class (u/bem :icon [:block :location])}]]
        [:span.tabular-list__item-name "F-6-B-2 "
         [:span {:class (u/bem :pill [:medium :picking-bin :blue])}
          "B-1212"]]
        [:span.tabular-list__item-value
         [:b "3"]]]
       [:li.tabular-list__item
        [:span.tabular-list__item-icon-wrapper
         [:i {:class (u/bem :icon [:block :location])}]]
        [:span.tabular-list__item-name "K-8-D-3 "
         [:span {:class (u/bem :pill [:medium :picking-bin :yellow])}
          "Y-909"]]
        [:span.tabular-list__item-value
         [:b "2"]]]]]]))
;;TODO: Can we add a 'Close' button to the bottom of the modal? It needs to be added outside these wrappers.

(defmethod grid/modal-config :picking/details-modal [_ _ _]
  {:body detail-modal-body})